import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { BodyM } from "@brexhq/shared/components/Typography/Components";
import { Span } from "@brexhq/shared/components/Typography/Typography";

import { FooterIconLinkGroup } from "./FooterIconLinkGroup";
import { FooterLink } from "./FooterLink";
import { IFooterColumns } from "./types";

const List = styled.ul({
  listStyle: "none",
  margin: 0,
  padding: 0,
});

export const FooterColumn: React.FC<IFooterColumns> = ({
  header,
  content,
  spacer,
}) => {
  const { colors } = useTheme();
  const isLogoColumn = content?.find(
    (el) => el._type === "iconLinkGroups" && el.groupType === "brexLogo",
  );
  if (spacer) {
    return (
      <Container
        width={{ LRG: "100%", MED: "100%", SML: isLogoColumn ? "100%" : "50%" }}
        padding={[0, "xsml", isLogoColumn ? 0 : "xlrg", 0]}
      ></Container>
    );
  }
  return (
    <Container
      width={{ LRG: "100%", MED: "100%", SML: isLogoColumn ? "100%" : "50%" }}
      padding={[0, "xsml", isLogoColumn ? 0 : "xlrg", 0]}
    >
      {header && (
        <BodyM as="h2" color={colors.content.inverse.primary}>
          <Span fontWeight={600}>{header}</Span>
        </BodyM>
      )}
      <List>
        {content.map((props, index: number) => {
          const type = props._type;
          const isLast = index === content.length - 1;
          return (
            <Container
              key={props._key}
              as="li"
              padding={{
                LRG: [
                  type === "iconLinkGroups" ? 0 : "xxsml",
                  0,
                  isLast && type !== "iconLinkGroups" ? "med" : 0,
                  0,
                ],
              }}
            >
              {type === "footerLink" ? (
                <FooterLink {...props} />
              ) : (
                <FooterIconLinkGroup {...props} />
              )}
            </Container>
          );
        })}
      </List>
    </Container>
  );
};
